const FRONT_URL = "https://www.chokhidhani.co.uk/"
// const API_URL = "http://127.0.0.1:8000/api/";
// const IMAGE_URL = "http://127.0.0.1:8000/storage/";

const API_URL = "https://cdnew.polysolinfotech.com/admin/public/api/";
const IMAGE_URL = "https://cdnew.polysolinfotech.com/admin/public/storage/";

const CATEGORIES = [];
const themesetting = {};
export default { API_URL, IMAGE_URL, CATEGORIES, FRONT_URL, themesetting };

